import { RegistrationStatusType } from "@/lib/gql/__generated__/graphql";

export const OptionsForRegistrationStatus = [
	{ id: RegistrationStatusType.NotRegistered, label: "未登録", value: RegistrationStatusType.NotRegistered }, //
	{ id: RegistrationStatusType.Pending, label: "申請中", value: RegistrationStatusType.Pending }, //
	{ id: RegistrationStatusType.Registered, label: "登録済み", value: RegistrationStatusType.Registered }, //
];
